import DynamicFieldsE2e from '@/views/e2e/DynamicFieldsE2e.vue';
const E2eRoutes = [
    {
        path: `/test/dynamic-fields/:id`,
        name: DynamicFieldsE2e.name,
        component: DynamicFieldsE2e,
        meta: {
            showAppHeader: false,
        },
    },
];
export default E2eRoutes;
